import React from 'react';
import packageJson from '../../package.json';

const VersionInfo: React.FC = () => {
  return (
    <div className="version-info">
      <small>v{packageJson.version} - Build: 2025-01-17 19:55 UTC - Auto-End Turn Debug</small>
    </div>
  );
};

export default VersionInfo;